import { customization } from '@yola/ws-sdk';
import getFontPairVariables from './get-font-pair-variables';

const compileFontPairConfig = (config) => {
  const defaultFontVariables = getFontPairVariables(
    config.parentId || customization.constants.FALLBACK_FONT_PAIR_ID
  );

  if (config.variables) {
    return {
      ...config,
      variables: {
        ...defaultFontVariables,
        ...config.variables,
      },
    };
  }

  const { variableOverrides } = config;

  if (!variableOverrides) {
    return { ...config, variables: { ...defaultFontVariables } };
  }

  return {
    ...config,
    variables: {
      ...defaultFontVariables,
      ...variableOverrides,
    },
  };
};

export default compileFontPairConfig;
